/*
 * domains (utils)
 */
import { AppEnv } from "./environment.utils"

export function getEnvDomainName(
	domain: string,
	env: string = AppEnv,
	addMissingHttps = false,
): string {
	if (env === "prod") {
		if (addMissingHttps && !domain.includes("://")) {
			return `https://${domain}`
		}
		return domain
	} else if (domain.includes("://")) {
		return domain.replace("://", `://${env}.`)
	}
	const envDomain = `${env}.${domain}`
	if (addMissingHttps) {
		return `https://${envDomain}`
	}
	return envDomain
}

export function getEnvDomainNames<T extends Record<string, string>>(
	domains: T,
	env: string = AppEnv,
	appendHttps = true,
) {
	const envDomains = {} as Record<keyof T, string>
	for (const key in domains) {
		let domain: string = domains[key]
		if (appendHttps && !domain.includes("://")) {
			domain = `https://${domain}`
		}
		envDomains[key] = getEnvDomainName(domain, env)
	}
	return envDomains
}
